/* eslint-disable no-unused-vars */

let ruleRequired = (value) => {
  return !!value
}

let ruleYesNo = (value) => {
  if (value === 1 || value === 0) return true
}

let ruleEmail = (value) => {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regex.test(value)
}

let ruleMinChars = (value, length) => {
  return value.length >= length
}

let ruleMaxChars = (value, length) => {
  return value.length <= length
}

let maxChars = (value, length) => {
  if (value) return value.length <= length
}

let minChars = (value, length) => {
  if (value) return value.length >= length
}

let ruleExactChars = (value, length) => {
  return value.length === length
}

let ruleNumeric = (value) => {
  return /^(\d*\.)?\d+$/.test(value)
}

let ruleDigits = (value) => {
  return /\d+$/.test(value)
}

// maxIntDigits and maxDecDigits must be >= 1
let ruleDecimal = (value, maxIntDigits, maxDecDigits) => {
  let decimalRegex = new RegExp('^\\d{1,' + maxIntDigits + '}(\\.\\d{1,' + maxDecDigits + '})?$')
  return decimalRegex.test(value)
}

let ruleText = (value) => {
  const textRegex = /([/#@*$%<=>·ªº\\/|\][^{}()+-])/
  return !textRegex.test(value)
}

let ruleFiveDigits = (value, length) => {
  return value.length >= 5
}

let ruleZip = (value) => {
  return /^(\d*\.)?\d+$/.test(value)
}

let ruleIsDecimal = (value) => {
  const pattern = /^(\d*\.)?\d+$/
  return pattern.test(value)
}

let ruleOnlyLetters = (value) => {
  return !(/[0-9]/.test(value))
}

let ruleNoSpace = (value) => {
  return !(/[\s]/.test(value))
}

let rulePassword = (value) => {
  return value !== undefined ? (value.length > 2) : false
}

const validationRules = function () {
  return {
    yesNoOption: [v => ruleYesNo(v) || this.$t('validation.required')],
    required: [v => ruleRequired(v) || this.$t('validation.required')],
    email: [v => ruleEmail(v) || this.$t('validation.invalidEmail')],
    zipcode: [
      v => ruleDigits(v) || this.$t('validation.invalidNumber'),
      v => ruleExactChars(v, 5) || this.$t('validation.fiveDigits')
    ],
    exchange: [v => ruleDecimal(v, 4, 6) || this.$t('validation.exchange')],
    textRules: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleText(v) || this.$t('validation.noSpecialChars'),
      v => ruleFiveDigits(v) || this.$t('validation.minNumberChars', {number: 5})
    ],
    textNoReq: [
      v => ruleText(v) || this.$t('validation.noSpecialChars')
    ],
    zipRules: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleZip(v) || this.$t('validation.invalidNumber'),
      v => ruleExactChars(v, 5) || this.$t('validation.fiveDigits')
    ],
    taxRules: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleMinChars(v, 12) || this.$t('validation.minNumberChars', {number: 12}),
      v => ruleMaxChars(v, 13) || this.$t('validation.maxNumberChars', {number: 13})
    ],
    phoneRules: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleMinChars(v, 10) || this.$t('validation.minNumberChars', {number: 10})
    ],
    counter: [
      v => ruleMaxChars(v, 20) || this.$t('validation.maxNumberChars', {number: 20})
    ],
    decimal: [
      v => ruleIsDecimal(v) || this.$t('validation.invalidDecimal')
    ],
    decimalMax2: [
      v => ruleDecimal(v, 6, 2) || this.$t('validation.pettyCashAdvance')
    ],
    onlyLetters: [
      v => ruleOnlyLetters(v) || this.$t('validation.onlyLetters')
    ],
    digits: [
      v => ruleDigits(v) || this.$t('validation.invalidNumber')
    ],
    minChars: [
      v => ruleMinChars(v, 3) || this.$t('validation.minNumberChars', {number: 3})
    ],
    minChars10: [
      v => minChars(v, 10) || this.$t('validation.minNumberChars', {number: 10})
    ],
    maxChars10: [
      v => maxChars(v, 10) || this.$t('validation.maxNumChars', {number: 10})
    ],
    maxChars30: [
      v => maxChars(v, 30) || this.$t('validation.maxNumChars', {number: 30})
    ],
    password: [
      v => rulePassword(v) || this.$t('validation.minNumberChars', {number: 3})
    ],
    minNameUser: [
      v => ruleMinChars(v, 5) || this.$t('validation.minNumberChars', {number: 5})
    ],
    noSpace: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleNoSpace(v) || this.$t('validation.noSpace')
    ],
    characters: [
      v => ruleMaxChars(v, 225) || this.$t('validation.maxNumChars', {number: 225})
    ],
    max1000Characters: [
      v => ruleMaxChars(v, 1000) || this.$t('validation.maxNumChars', {number: 1000})
    ],
    charactersProyectnumber: [
      v => ruleMaxChars(v, 10) || this.$t('validation.maxNumChars', {number: 10})
    ],
    charactersMax100: [
      v => !v || ruleMaxChars(v, 100) || this.$t('validation.maxNumChars', {number: 100})
    ],
    charactersText: [
      v => ruleMaxChars(v, 500) || this.$t('validation.maxNumChars', {number: 500})
    ],
    minChar: [
      v => ruleMinChars(v, 3) || this.$t('validation.minNumberChar', {number: 3})
    ],
    taxRul: [
      v => ruleRequired(v) || this.$t('validation.required'),
      v => ruleMinChars(v, 12) || this.$t('validation.minNumberChar', {number: 12}),
      v => ruleMaxChars(v, 13) || this.$t('validation.maxNumberChar', {number: 13})
    ],
    charactersMax30: [
      v => !v || ruleMaxChars(v, 30) || this.$t('validation.maxNumChars', {number: 30})
    ]
  }
}

export default validationRules



// WEBPACK FOOTER //
// ./src/form-validations/index.js